/**
 * Nevika Innovations Pvt Ltd — company constants.
 * Single source of truth for legal name, registration numbers, contact info
 * and registered office. Used across Legal pages, About sections, invoice /
 * email templates.
 *
 * DO NOT hardcode these values elsewhere — import from this file.
 */
export const COMPANY = Object.freeze({
  legal_name: 'Nevika Innovations Private Limited',
  short_name: 'Nevika Innovations',
  tagline: 'Infrastructure for the Future',

  cin: 'U62090MH2026OPC472128',
  gstin: '27AALCN7118G1Z9',

  registered_office: Object.freeze({
    line1: '1st Floor, Mapkhan Nagar',
    line2: 'Opp. Municipal School',
    area: 'Marol, Marol Naka',
    city: 'Andheri (East)',
    state: 'Maharashtra',
    postal_code: '400059',
    country: 'India',
    full: [
      '1st Floor, Mapkhan Nagar',
      'Opp. Municipal School',
      'Marol, Marol Naka',
      'Andheri (East)',
      'Mumbai – 400059',
      'Maharashtra, India',
    ].join(', '),
  }),

  website: 'https://www.nevika.co',
  email: 'info@nevika.co',
  phone: '+91 82919 98800',
  phone_alt: '+91 96994 09888',
});

/** Product-level defaults for Trivly (kept separate so we can spin out siblings). */
export const PRODUCT = Object.freeze({
  name: 'Trivly',
  tagline: 'Your travel mind.',
  url: 'https://trivly.ai',
  support_email: 'hello@trivly.ai',
});
